export default [
    {
        path: '/plan',
        component: () => import('../components/pages/plan/Plan.vue') ,
        meta: {
            title: '人才计划'
        }
    }

]